export default "__VITE_ASSET__CCJrzxqc__"